import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/site/Logo";
import { studioInfo } from "../mock";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-display text-2xl md:text-3xl text-white mb-4" style={{ textTransform: "none" }}>
      {title}
    </h2>
    <div className="text-white/65 text-[15px] leading-relaxed space-y-3">{children}</div>
  </div>
);

const PrivacyPage = () => {
  useEffect(() => {
    document.title = "ONEVO · Privacy & Cookie Policy";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <header className="border-b border-white/10">
        <div className="max-w-[900px] mx-auto px-6 md:px-8 h-24 flex items-center justify-between">
          <Link to="/"><Logo className="h-12" /></Link>
          <Link to="/" className="flex items-center gap-2 font-mono-label text-[10px] text-white/50 hover:text-white transition-colors">
            <ArrowLeft size={14} /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-6 md:px-8 py-16">
        <p className="font-mono-label text-[11px] text-white/45 mb-3">Documento legale</p>
        <h1 className="font-display text-4xl md:text-6xl text-white mb-4">Privacy &amp; Cookie Policy</h1>
        <p className="text-white/50 text-sm mb-12">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long" })}</p>

        <Section title="Titolare del trattamento">
          <p>
            Il Titolare del trattamento dei dati è <strong className="text-white">ONEVO Premium Training Studio S.r.l.s.</strong>,
            con sede legale in {studioInfo.address}, {studioInfo.city}.
          </p>
          <p>Partita IVA / Codice Fiscale: 13430580012 · REA: TO - 1362538</p>
          <p>Telefono: {studioInfo.phone}</p>
        </Section>

        <Section title="Quali dati raccogliamo">
          <p>
            Attraverso il modulo di contatto presente sul sito raccogliamo i dati che ci fornisci
            volontariamente: <strong className="text-white">nome e cognome, email, numero di telefono</strong>,
            l'eventuale obiettivo di allenamento e il messaggio facoltativo.
          </p>
          <p>
            Non raccogliamo dati particolari e non effettuiamo profilazione a fini pubblicitari.
          </p>
        </Section>

        <Section title="Finalità e base giuridica">
          <p>
            I dati vengono trattati esclusivamente per <strong className="text-white">rispondere alle tue
            richieste</strong> di informazioni e per fissare la consulenza iniziale. La base giuridica
            è il tuo consenso, espresso al momento dell'invio del modulo (art. 6 GDPR).
          </p>
        </Section>

        <Section title="Conservazione dei dati">
          <p>
            I dati sono conservati per il tempo strettamente necessario a gestire la tua richiesta e,
            successivamente, per gli adempimenti di legge. Puoi richiederne la cancellazione in
            qualsiasi momento.
          </p>
        </Section>

        <Section title="Cookie">
          <p>
            Questo sito utilizza <strong className="text-white">cookie tecnici</strong> necessari al
            corretto funzionamento (non richiedono consenso) e, <strong className="text-white">solo previo
            tuo consenso</strong>, cookie e contenuti di terze parti:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong className="text-white">Google Maps</strong> — per mostrare la mappa con la nostra sede.</li>
            <li><strong className="text-white">Google Fonts</strong> — per la resa tipografica del sito.</li>
          </ul>
          <p>
            Se rifiuti i cookie di terze parti, alcuni contenuti (come la mappa) non verranno caricati.
            Puoi modificare la tua scelta in qualsiasi momento cancellando i dati del sito dal browser.
          </p>
        </Section>

        <Section title="I tuoi diritti">
          <p>
            In qualità di interessato hai diritto di accedere ai tuoi dati, chiederne la rettifica o la
            cancellazione, limitarne od opporti al trattamento e richiederne la portabilità (artt. 15-22
            GDPR). Per esercitare questi diritti puoi contattarci al numero {studioInfo.phone}.
          </p>
        </Section>

        <div className="pt-8 border-t border-white/10">
          <Link to="/" className="font-mono-label text-[11px] text-white border border-white/25 px-6 py-3.5 rounded-md hover:bg-white/5 transition-colors inline-flex items-center gap-2">
            <ArrowLeft size={14} /> Torna alla home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
